export const DATE_ONLY_DISPLAY_FORMAT = 'dd/MM/yyyy';

export const isValidDate = value =>
  value instanceof Date && !Number.isNaN(value.getTime());

export const createUtcDateOnly = (year, monthIndex, day, boundary = 'end') => {
  if (![year, monthIndex, day].every(Number.isInteger)) return null;
  const isStart = boundary === 'start';
  const value = new Date(Date.UTC(
    year,
    monthIndex,
    day,
    isStart ? 0 : 23,
    isStart ? 0 : 59,
    isStart ? 0 : 59,
    0
  ));
  return value.getUTCFullYear() === year
    && value.getUTCMonth() === monthIndex
    && value.getUTCDate() === day
    ? value
    : null;
};

export const toDateOnlyValue = (value, boundary = 'end') =>
  isValidDate(value)
    ? createUtcDateOnly(value.getFullYear(), value.getMonth(), value.getDate(), boundary)
    : null;

export const normalizeDatePickerValue = (value, boundary = 'end') => {
  if (!Array.isArray(value)) return toDateOnlyValue(value, boundary);
  return [
    toDateOnlyValue(value[0], 'start'),
    toDateOnlyValue(value[1], 'end')
  ];
};

export const toPickerDate = value =>
  isValidDate(value)
    ? new Date(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate(), 12)
    : null;
